import secret from "../secret.json";

export const splitIntoChunks = (text, maxWords = 30) => {
  const chunks = [];
  const tempChunks = text.split(",");

  for (let i = 0; i < tempChunks.length; i += 1) {
    const words = tempChunks[i].split(" ");
    for (let j = 0; j < words.length; j += maxWords) {
      chunks.push(words.slice(j, j + maxWords).join(" "));
    }
  }

  return chunks;
};

export const formatDate = (datetime) => {
  if (!datetime) return "";
  // 지인에듀 수학은 ISO 모양(2026-10-05T14:20:00+09:00)으로 준다. 영어는 '2026/10/05 14:20'
  if (!datetime.includes("/")) return formatDateString(datetime);
  const [date] = datetime.split(" "); // 공백으로 날짜와 시간을 분리
  const [, month, day] = date.split("/"); // '/'로 나눠서 월과 일을 추출
  return `${month}/${day}`; // 원하는 형식으로 반환
};

export const formatDateString = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 월이 한 자리면 앞에 0 추가
  const day = String(date.getDate()).padStart(2, "0"); // 일이 한 자리면 앞에 0 추가
  return `${month}/${day}`; // 원하는 형식으로 반환
};

export const formatFullDateString = ({ dateString, defaultString }) => {
  if (!dateString) return defaultString;
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 월이 한 자리면 앞에 0 추가
  const day = String(date.getDate()).padStart(2, "0"); // 일이 한 자리면 앞에 0 추가
  const hours = String(date.getHours()).padStart(2, "0"); // 시간이 한 자리면 앞에 0 추가
  const minutes = String(date.getMinutes()).padStart(2, "0"); // 분이 한 자리면 앞에 0 추가
  const seconds = String(date.getSeconds()).padStart(2, "0"); // 초가 한 자리면 앞에 0 추가
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // 원하는 형식으로 반환
};

export const translateTypeName = (typeName) => {
  const typeMap = {
    analysis: "지문분석 워크북",
    comprehensive: "내용이해 워크북",
    paragraph: "모의고사 유형",
    vocabulary: "단어",
    sentence: "문장",
    grammar: "어법",
    readers_book: "리더스북",
    grammar_bank: "문법",
  };

  return typeMap[typeName] || typeName; // 매핑이 없으면 영어 그대로 반환
};

export const showGrade = (grade) => {
  const gradeMap = {
    1: "초1",
    2: "초2",
    3: "초3",
    4: "초4",
    5: "초5",
    6: "초6",
    7: "중1",
    8: "중2",
    9: "중3",
    10: "고1",
    11: "고2",
    12: "고3",
  };

  return gradeMap[grade] || grade;
};

export const showClass = (level_list) => {
  if (level_list.length === 0) {
    return "미배정";
  }
  return level_list.map((level) => level.name).join(", ");
};

export const showDate = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}년 ${month}월 ${day}일`;
};

export const roundScoreValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) {
    return null;
  }

  return Math.round(parsedValue * 100) / 100;
};

export const formatScore = (value) => {
  const roundedScore = roundScoreValue(value);
  if (roundedScore === null) {
    return "";
  }

  return roundedScore.toFixed(2).replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
};

export const showStudentList = ({ student_count, assignment_list }) => {
  if (student_count === 0) {
    return "미배정";
  } else if (student_count === 1) {
    return assignment_list[0].student.name;
  }
  return `${assignment_list[0].student.name} 외 ${student_count - 1}명`;
};

export const showStudentURL = (session) => {
  return `${secret.STUDENT_BASE_URL}/home?session=${session}`;
};
